import * as tslib_1 from "tslib";
import _ from 'lodash';
import dayjs from 'dayjs';
import { AssetType } from '@tradingblock/types';
import { PositionsUrl } from '../constants';
import { deriveRootSymbol, deriveOptionExpirationType } from '../utilities/SymbolUtilities';
export const get = (api) => {
    return (accountId, subaccountId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const res = yield api.get(PositionsUrl, { accountId, subaccountId });
        const { payload, responseCode } = res;
        const data = _.map(payload, (position) => {
            const isOption = position.AssetType === AssetType.Option;
            const PositionId = `${position.Symbol}-${dayjs(position.DateOpened).valueOf()}-${position.OrderId}`;
            const isMutualFund = position.AssetType === AssetType.MutualFund || position.AssetType === AssetType.MoneyMarket;
            const res = Object.assign({}, position, { PositionId, Symbol: isMutualFund ? ':' + position.Symbol : position.Symbol, UnderlyingSymbol: isMutualFund ? ':' + position.UnderlyingSymbol : position.UnderlyingSymbol, meta: {
                    OptionExpirationType: isOption
                        ? deriveOptionExpirationType(position.Symbol, position.UnderlyingSymbol)
                        : undefined,
                    RootSymbol: deriveRootSymbol(position.Symbol),
                    Description: position.Description
                } });
            return res;
        });
        return Object.assign({}, res, { payload: data, responseCode });
    });
};
//# sourceMappingURL=positions.js.map